import { render, staticRenderFns } from "./TradesLive.vue?vue&type=template&id=9a7e992c&scoped=true"
import script from "./TradesLive.vue?vue&type=script&lang=js"
export * from "./TradesLive.vue?vue&type=script&lang=js"
import style0 from "./TradesLive.vue?vue&type=style&index=0&id=9a7e992c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.29_cache-loader@4.1.0_webpack@4.47.0__css-load_b411938ae3dba6b80d9ee6ba07c3eefc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a7e992c",
  null
  
)

export default component.exports